module.exports = __webpack_public_path__ + "static/media/7.b23a2965.png";